import React from "react";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function ImagesSection() {
    UseScrollAnimation();
    return (
        <section className="relative pt-[40px] flex items-center">
            <img className="h-80-px js-scroll fade-top w-[20%] h-[350px]" src={require("../../assets/image/1-2 (1).JPG")} alt="" />
            <img className="h-80-px js-scroll fade-btm w-[20%] h-[350px]" src={require("../../assets/image/1-2 (2).JPG")} alt="" />
            <img className="h-80-px js-scroll fade-top w-[20%] h-[350px]" src={require("../../assets/image/1-2 (3).JPG")} alt="" />
            <img className="h-80-px js-scroll fade-btm w-[20%] h-[350px]" src={require("../../assets/image/1-2 (4).JPG")} alt="" />
            <img className="h-80-px js-scroll fade-top w-[20%] h-[350px]" src={require("../../assets/image/1-2 (1).PNG")} alt="" />
        </section>
    );
}